import { Observable } from 'rxjs';
import {
  AuthChangePasswordRequest,
  AuthChangePasswordResponse,
  AuthForgotPasswordRequest,
  AuthForgotPasswordResponse,
  AuthLoginRequest,
  AuthLoginResponse,
  AuthLogoutResponse,
  AuthLogoutRequest,
  AuthRefreshRequest,
  AuthRefreshResponse,
} from '../dto';
import { HttpResponse } from '@angular/common/http';

export abstract class AuthRepository {
  abstract login(credentials: AuthLoginRequest): Observable<HttpResponse<AuthLoginResponse>>;
  abstract forgotPassword(
    payload: AuthForgotPasswordRequest,
  ): Observable<HttpResponse<AuthForgotPasswordResponse>>;
  abstract changePassword(
    request: AuthChangePasswordRequest,
  ): Observable<HttpResponse<AuthChangePasswordResponse>>;
  abstract refreshToken(request: AuthRefreshRequest): Observable<HttpResponse<AuthRefreshResponse>>;
  abstract logout(request: AuthLogoutRequest): Observable<HttpResponse<AuthLogoutResponse>>;
}


